import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { cartSubtotalSelector, cartSubtotalTextilSelector } from 'redux/selectors/cart.selector';
import { getTotalAmount } from 'helpers/prices';

import Modal from 'components/commons/Modal';
import SecureCheckoutForm from 'components/forms/SecureCheckoutForm';

const SecureCheckoutContainer = (props) => {
  const {
    coupon, data: { callback, email, formData, total: totalFromData }, onClose, subtotal, subtotalTextil, client, envios,
    cartQuote,
  } = props;
  const envio = envios.find((envio) => envio.id.toString() === formData.delivery_method);
  const subTotEnv = formData.delivery_method
    ? envio?.monto_minimo !== 0 && subtotal >= envio?.monto_minimo 
      ? 0
      : envio?.calculated_by_system && cartQuote
        ? cartQuote.price
        : envio?.monto
    : 0;

  const total = totalFromData || (
    client?.design === 3
      ? getTotalAmount({ coupon, subtotal: subtotalTextil })
      : getTotalAmount({ coupon, subtotal })
  ) + (subTotEnv || 0);

  const onSubmit = async (card) => {
    setTimeout(() => {
      callback({ ...formData, card, transaction_amount: total});
      onClose();
    }, 2500);
  };

  return (
    <Modal onClose={onClose}>
      <SecureCheckoutForm
        email={email}
        onSubmit={onSubmit}
        total={total}
      />
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  coupon: state.cart.coupon,
  subtotal: cartSubtotalSelector(state),
  subtotalTextil: cartSubtotalTextilSelector(state),
  client: state.app.client,
  envios: state.app.envios,
  cartQuote: state.shipping.cartQuote,
});

SecureCheckoutContainer.defaultProps = {
  coupon: null,
};

SecureCheckoutContainer.propTypes = {
  coupon: PropTypes.shape({
    id: PropTypes.number.isRequired,
    percentage: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
  }),
  data: PropTypes.shape({
    callback: PropTypes.func.isRequired,
    email: PropTypes.string.isRequired,
    formData: PropTypes.shape().isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  subtotal: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, null)(SecureCheckoutContainer);
